export const defauldValueDependiente = {
  tipoIdentificacion: '0',
  numeroIdentificacion: '',
  nombreCompleto: '',
  dia: '',
  mes: '',
  year: '',
  genero: '',
  parentesco: '',
};

export const defauldValuesFormDependientes = {
  dependientes: [],
};
